// extracted by mini-css-extract-plugin
module.exports = {"container":"StackHeader__container___+pa4w","title":"StackHeader__title___NHx9B","repo":"StackHeader__repo___ZiSGT"};